// extracted by mini-css-extract-plugin
export default {"graphTitle":"SaveValuesTab_graphTitle__BJQP+","titleBox":"SaveValuesTab_titleBox__AudNb","helpBlock":"SaveValuesTab_helpBlock__bhh25"};